export default "__VITE_ASSET__toMqwJ9AnYgx8OqHxnFaOw__"